import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareNotificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-notifications',
	path: '/jira/software/projects/:projectKey/settings/notifications',
	exact: true,
};
